// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TGetDocumentSuggestionRequestPayload,
  TGetDocumentSuggestionResponsePayload,
  TListDocumentSuggestionsRequestPayload,
  TListDocumentSuggestionsResponsePayload,
  TUpdateDocumentSuggestionRequestPayload,
  TUpdateDocumentSuggestionResponsePayload,
} from './document-suggestions.types.ts';

export const createDocumentSuggestionsApi = (transport: TApiTransport) => ({
  /** Returns a document suggestion */
  getDocumentSuggestion: (
    payload: TGetDocumentSuggestionRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetDocumentSuggestionRequestPayload,
      TGetDocumentSuggestionResponsePayload
    >('/get_document_suggestion', payload, options),

  /** Lists document suggestions */
  listDocumentSuggestions: (
    payload: TListDocumentSuggestionsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TListDocumentSuggestionsRequestPayload,
      TListDocumentSuggestionsResponsePayload
    >('/list_document_suggestions', payload, options),

  /** Updates a document suggestion */
  updateDocumentSuggestion: (
    payload: TUpdateDocumentSuggestionRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateDocumentSuggestionRequestPayload,
      TUpdateDocumentSuggestionResponsePayload
    >('/update_document_suggestion', payload, options),
});
